var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5226_1948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.667 12.2163V16.6663C16.667 17.1084 16.4914 17.5323 16.1788 17.8449C15.8663 18.1574 15.4424 18.333 15.0003 18.333H3.33366C2.89163 18.333 2.46771 18.1574 2.15515 17.8449C1.84259 17.5323 1.66699 17.1084 1.66699 16.6663V4.99967C1.66699 4.55765 1.84259 4.13372 2.15515 3.82116C2.46771 3.5086 2.89163 3.33301 3.33366 3.33301H7.78366",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 1.66699L18.3337 5.00033L10.0003 13.3337H6.66699V10.0003L15.0003 1.66699Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5226_1948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.5bdd49bd.svg";
export { ForwardRef as ReactComponent };